// src/app/redux/sagas/changeRequestSagas.js

import { call, put, takeLatest } from 'redux-saga/effects';
import { getRequest, postRequest } from '../../../api';
import Swal from "sweetalert2";
import {
    FETCH_ALL_REQUESTS_REQUEST,
    FETCH_ALL_REQUESTS_SUCCESS,
    FETCH_ALL_REQUESTS_FAIL,
    FETCH_PENDING_FIELDS_REQUEST,
    FETCH_PENDING_FIELDS_SUCCESS,
    FETCH_PENDING_FIELDS_FAIL,
    VALIDATE_REQUEST_REQUEST,
    VALIDATE_REQUEST_SUCCESS,
    VALIDATE_REQUEST_FAIL,
} from '../actions/changeRequestActions';

import { API_BASE_URL } from '../../../api';

const API_URL = `${API_BASE_URL}/api/user-change-requests`;

function* fetchAllRequestsSaga(action) {
    try {
        const url = `${API_URL}/all?companyId=${action.payload}`;
        const response = yield call(getRequest, { 
            url, 
            token: sessionStorage.getItem('token') 
        });
        yield put({ type: FETCH_ALL_REQUESTS_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: FETCH_ALL_REQUESTS_FAIL, payload: error.message });
    }
}

function* fetchPendingFieldsSaga(action) {
    try {
        const url = `${API_URL}/pending-fields?userId=${action.payload}`;
        const response = yield call(getRequest, { 
            url, 
            token: sessionStorage.getItem('token') 
        });
        yield put({ type: FETCH_PENDING_FIELDS_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: FETCH_PENDING_FIELDS_FAIL, payload: error.message });
    }
}

function* validateRequestSaga(action) {
    try {
        const { id, status, validatorId, reason, companyId } = action.payload;
        let url = `${API_URL}/${id}/validate?status=${status}&validatorId=${validatorId}`;
        
        const response = yield call(postRequest, { 
            url, 
            data: reason || "", 
            token: sessionStorage.getItem('token') 
        });
        
        yield put({ type: VALIDATE_REQUEST_SUCCESS, payload: response.data });
        
        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: status.toLowerCase() === 'approved' ? 'Demande approuvée avec succès' : 'Demande refusée',
            timer: 2000,
            showConfirmButton: false
        });

        const refreshCompanyId = companyId || sessionStorage.getItem('companyId') || 1; 
        yield put({ type: FETCH_ALL_REQUESTS_REQUEST, payload: refreshCompanyId });

    } catch (error) {
        yield put({ type: VALIDATE_REQUEST_FAIL, payload: error.message });
        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: "Erreur lors du traitement de la demande",
            timer: 2500,
            showConfirmButton: false
        });
    }
}

export default function* changeRequestSaga() {
    yield takeLatest(FETCH_ALL_REQUESTS_REQUEST, fetchAllRequestsSaga);
    yield takeLatest(FETCH_PENDING_FIELDS_REQUEST, fetchPendingFieldsSaga);
    yield takeLatest(VALIDATE_REQUEST_REQUEST, validateRequestSaga);
}
